import templateOnly, { type TOC } from "@ember/component/template-only";

interface JournalEvent {
  createdAt: Date;
  updatedAt: Date;
}

interface Signature {
  Element: HTMLDivElement;
  Args: {
    title?: string;
    headerHidden?: boolean;
    dontUseTextWidthLimit?: boolean;
    retrievedJournalEvent?: JournalEvent;
    background?: "transparent";
    class?: string;
  };
  Blocks: {
    content: [];
    headerWidget: [];
  };
}

const PageContainerComponent: TOC<Signature> = templateOnly();
export default PageContainerComponent;
